const DOB_MDY_REGEX = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const DOB_ISO_REGEX = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Normalize any known DOB representation to the canonical UI format MM/DD/YYYY.
 * Accepts ISO (YYYY-MM-DD), ISO+Z (YYYY-MM-DDT00:00:00.000Z), or MM/DD/YYYY pass-through.
 * Returns empty string for blank/unrecognized input.
 */
export function toMdy(value: string): string {
  const trimmed = value.trim();
  if (trimmed === '') return '';
  if (DOB_MDY_REGEX.test(trimmed)) return trimmed;
  const isoMatch = trimmed.match(DOB_ISO_REGEX);
  if (isoMatch) {
    const [, yyyy, mm, dd] = isoMatch;
    return `${mm}/${dd}/${yyyy}`;
  }
  return '';
}

/** MM/DD/YYYY → YYYY-MM-DDT00:00:00.000Z  (DoseSpot APIs) */
export function toDobIsoZ(dobMdy: string): string {
  const match = dobMdy.trim().match(DOB_MDY_REGEX);
  if (!match) return `${dobMdy.trim()}T00:00:00.000Z`;
  const [, mm, dd, yyyy] = match;
  return `${yyyy}-${mm}-${dd}T00:00:00.000Z`;
}

/** MM/DD/YYYY → YYYY-MM-DD  (credentialing / generic ISO date) */
export function toDobIso(dobMdy: string): string {
  const match = dobMdy.trim().match(DOB_MDY_REGEX);
  if (!match) return dobMdy.trim();
  const [, mm, dd, yyyy] = match;
  return `${yyyy}-${mm}-${dd}`;
}

/** Mask raw keyboard input into MM/DD/YYYY as the user types. */
export function maskDobMdyInput(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  const mm = digits.slice(0, 2);
  const dd = digits.slice(2, 4);
  const yyyy = digits.slice(4, 8);

  if (digits.length <= 2) return mm;
  if (digits.length <= 4) return `${mm}/${dd}`;
  return `${mm}/${dd}/${yyyy}`;
}
